import type { FunctionComponent } from 'react'

import styles from './article-image.module.scss'
import { Image } from '../../components/image'
import type { LargeImageFragment } from '../../graphql/fragments/LargeImageFragment.graphql'

/**
 * Dispays a standalone image section.
 */
export const ArticleImage: FunctionComponent<LargeImageFragment> = (image) => (
    <div className={styles.section}>
        <Image
            source={image.source}
            source2x={image.source2x}
            source3x={image.source3x}
            contentType={image.contentType}
            alt={image.alt}
            lazy={false}
            fit='contain'
            width='100%'
        />
    </div>
)
